import {Injectable} from '@angular/core';
import {NotificationService} from '../../firebase/notification.service';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {from, firstValueFrom, Observable} from 'rxjs';
import {
    ClearNotificationTokenAction,
    NotificationAction,
    NotificationActionType, NotificationTestAction,
    NotificationTokenFetchFailedAction,
    NotificationTokenFetchSucceededAction,
    NotificationTokenPersistAction, NotificationTokenPersistFailedAction, NotificationTokenPersistSucceededAction,
    NotificationTokenRequestedAction
} from './notification.actions';
import {map, pluck, switchMap} from 'rxjs/operators';
import * as AuthActions from '../auth/auth.actions';


@Injectable()
export class NotificationEffects {

    constructor(
        private notificationService: NotificationService,
        private actions$: Actions
    ) {}

    
    login$: Observable < NotificationAction > = createEffect(() => this.actions$
        .pipe(
            ofType(AuthActions.authenticatedAction),
            map((action) => {
                return new NotificationTokenRequestedAction(action.userData.uid);
            })
        ));

    
    notificationTokenRequested$: Observable <NotificationAction> = createEffect(() => this.actions$
        .pipe(
            ofType(NotificationActionType.NOTIFICATION_TOKEN_REQUESTED),
            pluck('payload'),
            switchMap((payload: any) => {
                return this.notificationService.getToken()
                    .then(token => {
                        if(token != null){
                            return new NotificationTokenFetchSucceededAction(token, payload.userID);
                        } else {
                            throw new Error(`Null token`);
                        }
                    })
                    .catch(error => {
                        //console.error(`token fetch failed`, error);
                        return new NotificationTokenFetchFailedAction(error);
                    });
            })
        ));

    
    notificationTokenFetchSucceeded$: Observable < NotificationAction > = createEffect(() => this.actions$
        .pipe(
            ofType(NotificationActionType.NOTIFICATION_TOKEN_FETCH_SUCCEEDED),
            pluck('payload'),
            map((payload: any) => {
                return new NotificationTokenPersistAction(payload.token, payload.userID);
            })
        ));

    
    notificationTokenPersist$: Observable <NotificationAction> = createEffect(() => this.actions$
        .pipe(
            ofType(NotificationActionType.NOTIFICATION_TOKEN_PERSIST),
            pluck('payload'),
            switchMap((payload: any) => {
                return firstValueFrom(this.notificationService.persistFCMToken(payload))
                    .then(token => {
                        return new NotificationTokenPersistSucceededAction(token);
                    })
                    .catch(error => {
                        //console.error(error);
                        return new NotificationTokenPersistFailedAction(error);
                    });
            })
        ));

    
    logout$: Observable < NotificationAction > = createEffect(() => this.actions$
        .pipe(
            ofType(AuthActions.logoutAction),
            map(() => new ClearNotificationTokenAction())
        ));

    
    notificationTest$ = createEffect(() => this.actions$
        .pipe(
            ofType(NotificationActionType.NOTIFICATION_TEST),
            switchMap((action: NotificationTestAction) => {
                return from(this.notificationService.sendTestNotification(action.payload.token));
            })
        ), {dispatch: false});
}
